import { Checkbox } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { SET_CONSOLIDATION } from 'store/key';

const useAttendanceMember = ({ isViewOnly, rows }) => {
    const dispatch = useDispatch();
    const consolidationDetail = useSelector(state => state.consolidationDetail);

    const columns = [
        {
            field: 'attendMeeting',
            headerName: 'Attend Meeting?',
            width: 120,
            renderCell: (params) => {
                return <Checkbox
                    disabled={isViewOnly}
                    checked={params.row.attendMeeting}
                    color="primary"
                    onChange={() => changeAttend(params.row, !params.row.attendMeeting)}
                />;
            },
        },
        {
            field: 'chairman',
            headerName: 'Chairman',
            width: 80,
            renderCell: (params) => {
                return params.row.chairman ? 'Yes' : 'No';
            },
        },
        { field: 'email', headerName: 'Email', width: 180 },
        {
            field: 'reviewPanels', headerName: 'Review Panel', width: 200,
            renderCell: (params) => {
                if (!params.row.reviewPanels.length) return '-';
                let panel = '';
                const list = params.row.reviewPanels;
                list.forEach((item, index) => {
                    panel += item.panelName + (index < list.length - 1 ? ', ' : '');
                });
                return panel;
            }
        },
        { field: 'title', headerName: 'Title', width: 80 },
        { field: 'surname', headerName: 'Surname', width: 80 },
        { field: 'firstName', headerName: 'First Name', width: 120 },
        { field: 'gender', headerName: 'Gender', width: 80,
            renderCell: (params) => {
                return params.row.gender === 'F' ? 'Female' : 'Male';
            }
        },
        { field: 'institution', headerName: 'Institution', width: 120 },
        { field: 'department', headerName: 'Department', width: 140 },
        { field: 'post', headerName: 'Post', width: 100 },
        { field: 'background', headerName: 'Background', width: 200, },
        {
            field: 'independent',
            headerName: 'Independent',
            width: 120,
            renderCell: (params) => {
                return params.row.independent === '1' ? 'Yes' : 'No';
            }
        },
    ];

    const changeAttend = (row, value) => {
        const copyRows = JSON.parse(JSON.stringify(rows));
        const index = copyRows.findIndex(item => item.userId === row.userId);
        copyRows[index].attendMeeting = value;

        let ids = [];
        copyRows.forEach(item => {
            if (item.attendMeeting) {
                ids.push(item.userId);
            }
        });

        dispatch({
            type: SET_CONSOLIDATION,
            payload: {
                rows: copyRows,
                detail: {
                    ...consolidationDetail.detail,
                    attendMeetingUserId: ids.length ? ids : null,
                }
            }
        })
    };

    return { columns: columns };
};

export default useAttendanceMember;
